import React, { useMemo, useState } from "react"
import { Box, Hidden } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import InfiniteScroll from "react-infinite-scroll-component"
import { ActionCreator, ProcessStepActionCard, SectionTitle, Avatar } from ".."
import { Icon } from "../Icon"
import { ExpansionPanelTitle } from "../ExpansionPanel"
import { TextDivider } from "../TextDivider"
import { PreviewChip } from "../Chips/PreviewChip"
import { toId } from "../../utils"

const useStyles = makeStyles((theme) => ({
  stepNumber: {
    width: 48,
    height: 48,
    backgroundColor: theme.palette.avatar.number.background,
    color: theme.palette.avatar.number.color,
    fontSize: 20,
    fontWeight: "600",
  },
  previewChip: {
    marginLeft: theme.spacing(1),
  },
  expansionRoot: {},
  expansionIcon: {
    margin: `0 ${theme.spacing(3)}px 0 13px`,
  },
  expansionSummary: {
    minHeight: 54,
  },
  expansionDetail: {},
}))

const pageSize = 8

const ProcessSteps = ({ job, steps, isScheduled, isPreview, scrollableTarget }) => {
  const classes = useStyles()
  const [action, setAction] = useState(false)
  const [limit, setLimit] = useState(pageSize)

  const expansionClasses = {
    root: classes.expansionRoot,
    icon: classes.expansionIcon,
    summary: classes.expansionSummary,
    detail: classes.expansionDetail,
  }

  const handleCreateAction = (step) => {
    setAction(step)
  }

  const handleCloseAction = () => {
    setAction(false)
  }

  const loadMore = () => {
    setLimit(Math.min(limit + pageSize, steps.length || 0))
  }

  const visibleSteps = useMemo(() => steps.slice(0, limit), [limit, steps])

  const hasMore = steps.length > limit

  return (
    <>
      {action && <ActionCreator open={Boolean(action)} job={job} step={action} onClose={handleCloseAction} />}

      <Box mb={5}>
        <Hidden xsDown>
          <SectionTitle>
            Process steps
            {isPreview && <PreviewChip className={classes.previewChip} />}
          </SectionTitle>
          <Box id="Box-steps">
            <Box display="flex" flexDirection="column" flexGrow={1}>
              <InfiniteScroll
                dataLength={visibleSteps.length}
                next={loadMore}
                hasMore={hasMore}
                scrollableTarget={scrollableTarget}
                style={{ overflow: "visible" }}
              >
                {visibleSteps.map((step, index) => (
                  <Box key={toId(step)} id={toId(step)} display="flex" flexDirection="row">
                    <Hidden xsDown>
                      <Box mr={3}>
                        <Avatar number={index + 1} className={classes.stepNumber} />
                      </Box>
                    </Hidden>
                    <Box flexGrow={1}>
                      <ProcessStepActionCard
                        job={job}
                        step={step}
                        isScheduled={isScheduled}
                        isPreview={isPreview}
                        onCreateAction={handleCreateAction}
                      />
                    </Box>
                  </Box>
                ))}
              </InfiniteScroll>
            </Box>
          </Box>
        </Hidden>
        <Hidden smUp>
          <TextDivider />
          <Box display="flex" alignItems="center" my={2}>
            <ExpansionPanelTitle
              icon={<Icon name="process" />}
              title={
                <>
                  Process steps
                  {isPreview && <PreviewChip className={classes.previewChip} />}
                </>
              }
              description={`${steps.length} steps`}
              classes={expansionClasses}
            />
          </Box>
          <Box display="flex" flexDirection="column" flexGrow={1}>
            <InfiniteScroll
              dataLength={visibleSteps.length}
              next={loadMore}
              hasMore={hasMore}
              scrollableTarget={scrollableTarget}
              style={{ overflow: "visible" }}
            >
              {visibleSteps.map((step, index) => (
                <Box key={toId(step)} display="flex" flexDirection="row">
                  <Hidden xsDown>
                    <Box mr={3}>
                      <Avatar number={index + 1} className={classes.stepNumber} />
                    </Box>
                  </Hidden>
                  <Box flexGrow={1}>
                    <ProcessStepActionCard
                      job={job}
                      step={step}
                      isScheduled={isScheduled}
                      isPreview={isPreview}
                      onCreateAction={handleCreateAction}
                    />
                  </Box>
                </Box>
              ))}
            </InfiniteScroll>
          </Box>
        </Hidden>
      </Box>
    </>
  )
}

export { ProcessSteps }
